var exports = {
  "kL": "ExpressionHoverTooltipContent.module__container___bGRYa0",
  "VH": "ExpressionHoverTooltipContent.module__preview___bGRYa0",
  "Qq": "ExpressionHoverTooltipContent.module__text___bGRYa0",
  "UU": "ExpressionHoverTooltipContent.module__name___bGRYa0",
  "aK": "ExpressionHoverTooltipContent.module__hint___bGRYa0",
};

module.exports = exports;
